/* R&B · Refine v2 (assets/rb-refine.css, snippets/facets.liquid form.rbrf).
   1. Filter sections open and close in place with a .34s height animation (the theme's drawer would slide each in as a page).
   2. When the drawer opens, the sections that hold a choice are open (or the first one).
   3. The button says "Show 33 styles" and follows every change (the count is re-rendered by the theme after each filter). */
(function () {
  var EASE = 'cubic-bezier(.22,.61,.36,1)';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  function sections(form) { return [].slice.call(form.querySelectorAll('.mobile-facets__main > details.mobile-facets__details')); }

  document.addEventListener('click', function (e) {
    var sum = e.target.closest && e.target.closest('form.rbrf .mobile-facets__main > details.mobile-facets__details > summary');
    if (!sum) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var d = sum.parentNode, body = d.querySelector(':scope > .mobile-facets__submenu');
    if (d._rbfAnim) { d._rbfAnim.cancel(); d._rbfAnim = null; }
    if (d.open) {
      sum.setAttribute('aria-expanded', 'false');
      if (reduce.matches || !body || !body.animate) { d.open = false; return; }
      d.classList.add('rbf-closing');
      d._rbfAnim = body.animate([{ height: body.offsetHeight + 'px' }, { height: '0px' }], { duration: 340, easing: EASE });
      d._rbfAnim.onfinish = function () { d.open = false; d.classList.remove('rbf-closing'); d._rbfAnim = null; };
    } else {
      d.open = true;
      sum.setAttribute('aria-expanded', 'true');
      if (reduce.matches || !body || !body.animate) return;
      d._rbfAnim = body.animate([{ height: '0px' }, { height: body.offsetHeight + 'px' }], { duration: 340, easing: EASE });
      d._rbfAnim.onfinish = function () { d._rbfAnim = null; };
    }
  }, true);

  function openDefaults(form) {
    var list = sections(form);
    if (!list.length || list.some(function (d) { return d.open; })) return;
    var act = list.filter(function (d) { return d.hasAttribute('data-rbf-active') || d.querySelector('input:checked'); });
    (act.length ? act : list.slice(0, 1)).forEach(function (d) { d.open = true; var s = d.querySelector(':scope > summary'); if (s) s.setAttribute('aria-expanded', 'true'); });
  }
  function label(form) {
    var src = form.querySelector('[data-rbf-go]'), btn = form.querySelector('[data-rbf-btn]');
    if (src && btn && btn.textContent.trim() !== src.textContent.trim()) btn.textContent = src.textContent.trim();
  }
  function init(form) {
    if (form._rbf) return;
    form._rbf = true;
    var disc = form.closest('details.mobile-facets__disclosure');
    if (disc) disc.addEventListener('toggle', function () { if (disc.open) { openDefaults(form); label(form); } });
    // the heading shows the choices at once (the theme re-renders every section except the one being used)
    form.addEventListener('change', function (e) {
      var d = e.target.closest && e.target.closest('.mobile-facets__main > details.mobile-facets__details');
      var sum = d && d.querySelector(':scope > summary .rbf-sum');
      if (!sum) return;
      // "Category (1)" follows at once (the theme re-renders this group last)
      var n = d.querySelectorAll('input[type="checkbox"]:checked').length, c = d.querySelector(':scope > summary .rbf-c');
      if (!c && n) { c = document.createElement('span'); c.className = 'rbf-c'; var lab = d.querySelector(':scope > summary > div > span'); if (lab) { lab.appendChild(document.createTextNode(' ')); lab.appendChild(c); } }
      if (c) c.textContent = n ? '(' + n + ')' : '';
      sum.textContent = [].map.call(d.querySelectorAll('input:checked'), function (i) {
        var l = i.closest('label'), t = l && l.querySelector('.facet-checkbox__text-label');
        return t ? t.textContent.trim() : '';
      }).filter(Boolean).join(', ');
    });
    if ('MutationObserver' in window) new MutationObserver(function () { label(form); }).observe(form, { childList: true, subtree: true, characterData: true });
    label(form);
  }
  function boot() { [].forEach.call(document.querySelectorAll('form.rbrf'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
